import { Option } from "@opendaw/lib-std";
export var BpmDetector;
(function (BpmDetector) {
    BpmDetector.Unknown = {
        detect: async (_audioData, progress) => {
            progress(1.0);
            return Option.None;
        }
    };
})(BpmDetector || (BpmDetector = {}));
